module.exports = __webpack_public_path__ + "static/img/D200X4_bg.f77be53.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/D200X4_bg.jpeg
// module id = mkIb
// module chunks = 0